<section>
  <p>
    Hmm, that page doesn't seem to exist. Try going back to the <a routerLink="/" aria-label="Homepage">home page</a>.
  </p>
</section>
